/**
 * One colour per editor tab, shared by the tab pill, the section panel,
 * and the step cards inside it.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { StepTone } from '@/components/ui';

export type EditorTabKey =
  | 'general'
  | 'groups'
  | 'gateways'
  | 'creative'
  | 'options'
  | 'verdicts'
  | 'autosend';

export interface TabChrome {
  step: StepTone;
  idle: string;
  active: string;
  icon: string;
  panel: string;
  badge: string;
  heading: string;
}

export const TAB_CHROME: Record<EditorTabKey, TabChrome> = {
  general: {
    step: 'sky',
    idle: 'text-muted-foreground hover:bg-sky-500/10 hover:text-foreground',
    active: 'bg-sky-500/15 text-sky-950 ring-1 ring-inset ring-sky-500/40 dark:text-sky-100',
    icon: 'text-sky-600 dark:text-sky-400',
    panel: 'bg-sky-500/[0.06] ring-1 ring-inset ring-sky-500/25',
    badge: 'bg-sky-500/20 text-sky-900 dark:text-sky-100',
    heading: 'text-sky-800 dark:text-sky-200',
  },
  groups: {
    step: 'violet',
    idle: 'text-muted-foreground hover:bg-violet-500/10 hover:text-foreground',
    active: 'bg-violet-500/15 text-violet-950 ring-1 ring-inset ring-violet-500/40 dark:text-violet-100',
    icon: 'text-violet-600 dark:text-violet-400',
    panel: 'bg-violet-500/[0.06] ring-1 ring-inset ring-violet-500/25',
    badge: 'bg-violet-500/20 text-violet-900 dark:text-violet-100',
    heading: 'text-violet-800 dark:text-violet-200',
  },
  gateways: {
    step: 'amber',
    idle: 'text-muted-foreground hover:bg-amber-500/10 hover:text-foreground',
    active: 'bg-amber-500/15 text-amber-950 ring-1 ring-inset ring-amber-500/40 dark:text-amber-100',
    icon: 'text-amber-600 dark:text-amber-400',
    panel: 'bg-amber-500/[0.07] ring-1 ring-inset ring-amber-500/30',
    badge: 'bg-amber-500/20 text-amber-950 dark:text-amber-100',
    heading: 'text-amber-800 dark:text-amber-200',
  },
  creative: {
    step: 'rose',
    idle: 'text-muted-foreground hover:bg-rose-500/10 hover:text-foreground',
    active: 'bg-rose-500/15 text-rose-950 ring-1 ring-inset ring-rose-500/40 dark:text-rose-100',
    icon: 'text-rose-600 dark:text-rose-400',
    panel: 'bg-rose-500/[0.06] ring-1 ring-inset ring-rose-500/25',
    badge: 'bg-rose-500/20 text-rose-900 dark:text-rose-100',
    heading: 'text-rose-800 dark:text-rose-200',
  },
  options: {
    step: 'teal',
    idle: 'text-muted-foreground hover:bg-teal-500/10 hover:text-foreground',
    active: 'bg-teal-500/15 text-teal-950 ring-1 ring-inset ring-teal-500/40 dark:text-teal-100',
    icon: 'text-teal-600 dark:text-teal-400',
    panel: 'bg-teal-500/[0.06] ring-1 ring-inset ring-teal-500/25',
    badge: 'bg-teal-500/20 text-teal-900 dark:text-teal-100',
    heading: 'text-teal-800 dark:text-teal-200',
  },
  verdicts: {
    step: 'fuchsia',
    idle: 'text-muted-foreground hover:bg-fuchsia-500/10 hover:text-foreground',
    active: 'bg-fuchsia-500/15 text-fuchsia-950 ring-1 ring-inset ring-fuchsia-500/40 dark:text-fuchsia-100',
    icon: 'text-fuchsia-600 dark:text-fuchsia-400',
    panel: 'bg-fuchsia-500/[0.06] ring-1 ring-inset ring-fuchsia-500/25',
    badge: 'bg-fuchsia-500/20 text-fuchsia-900 dark:text-fuchsia-100',
    heading: 'text-fuchsia-800 dark:text-fuchsia-200',
  },
  autosend: {
    step: 'emerald',
    idle: 'text-muted-foreground hover:bg-emerald-500/10 hover:text-foreground',
    active: 'bg-emerald-500/15 text-emerald-950 ring-1 ring-inset ring-emerald-500/40 dark:text-emerald-100',
    icon: 'text-emerald-600 dark:text-emerald-400',
    panel: 'bg-emerald-500/[0.06] ring-1 ring-inset ring-emerald-500/25',
    badge: 'bg-emerald-500/20 text-emerald-900 dark:text-emerald-100',
    heading: 'text-emerald-800 dark:text-emerald-200',
  },
};
